/**
 * @generated SignedSource<<15bb49a5079b242eb34382ed96085c20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortOrder = "ASC" | "DESC";
export type learnTrackingRow_Query$variables = {
  filterByCompletedCourses?: boolean | null;
  filterByGroupIds?: ReadonlyArray<string> | null;
  filterByMaxDate?: string | null;
  filterByMinDate?: string | null;
  filterByText?: string | null;
  filterByUserId?: string | null;
  sortByUserLastName?: SortOrder | null;
};
export type learnTrackingRow_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"learnStatesExportButton_QueryFragment">;
};
export type learnTrackingRow_Query = {
  response: learnTrackingRow_Query$data;
  variables: learnTrackingRow_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByCompletedCourses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByGroupIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByMaxDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByMinDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByText"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByUserId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortByUserLastName"
},
v7 = [
  {
    "kind": "Variable",
    "name": "filterByCompletedCourses",
    "variableName": "filterByCompletedCourses"
  },
  {
    "kind": "Variable",
    "name": "filterByGroupIds",
    "variableName": "filterByGroupIds"
  },
  {
    "kind": "Variable",
    "name": "filterByMaxDate",
    "variableName": "filterByMaxDate"
  },
  {
    "kind": "Variable",
    "name": "filterByMinDate",
    "variableName": "filterByMinDate"
  },
  {
    "kind": "Variable",
    "name": "filterByText",
    "variableName": "filterByText"
  },
  {
    "kind": "Variable",
    "name": "filterByUserId",
    "variableName": "filterByUserId"
  },
  {
    "kind": "Variable",
    "name": "sortByUserLastName",
    "variableName": "sortByUserLastName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "learnTrackingRow_Query",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "learnStatesExportButton_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "learnTrackingRow_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearntrackingViewerSchema",
            "kind": "LinkedField",
            "name": "Learntracking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "kind": "ScalarField",
                "name": "csv",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5246f2bd8502771f10cf5c7d51c35f96",
    "id": null,
    "metadata": {},
    "name": "learnTrackingRow_Query",
    "operationKind": "query",
    "text": "query learnTrackingRow_Query(\n  $filterByUserId: ID\n  $sortByUserLastName: SortOrder\n  $filterByText: String\n  $filterByMinDate: LocalDate\n  $filterByMaxDate: LocalDate\n  $filterByGroupIds: [ID!]\n  $filterByCompletedCourses: Boolean\n) {\n  ...learnStatesExportButton_QueryFragment_2lDMqa\n}\n\nfragment learnStatesExportButton_QueryFragment_2lDMqa on Query {\n  Viewer {\n    Learntracking {\n      csv(filterByUserId: $filterByUserId, sortByUserLastName: $sortByUserLastName, filterByText: $filterByText, filterByMinDate: $filterByMinDate, filterByMaxDate: $filterByMaxDate, filterByGroupIds: $filterByGroupIds, filterByCompletedCourses: $filterByCompletedCourses)\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb0df8da2cdefc548df8c56725cdae57";

export default node;
